module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_13.2f8168f3.pdf";